module.exports = __webpack_public_path__ + "static/media/twitter.a47ff9d3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/twitter.svg
 ** module id = 147
 ** module chunks = 0
 **/